import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import Swal from 'sweetalert2';
import AddTipoPartidaContable from './AddTipoPartidaContable';
import { useAccesos } from '../contexts/AccesosContext';


function GestionTipoPartidaContable() {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tiposPartidaContable, setTiposPartidaContable] = useState([]);
    const [editTipoPartidaContable, setEditTipoPartidaContable] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [tipoPartidaContableToDelete, setTipoPartidaContableToDelete] = useState(null);
    const { user } = useUser();  
    const { tienePermiso } = useAccesos();


        const fetchTiposPartidasContables = async () => {
                try {
                    const response = await fetch(`${server}/CtbTipoPartidums`);
                    const data = await response.json();
                    setTiposPartidaContable(data.$values);
                    
                } catch (error) {
                    console.error('Error al cargar los Tipos de partidas contables:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los Tipos de partidas contables: ' + error,
                    });
                }
            };
    
        
            useEffect(() => {
                fetchTiposPartidasContables();
            }, []);
        
            const handleNewTipoPartidaContable = () => {
                fetchTiposPartidasContables();
                setEditTipoPartidaContable(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (tipoPartidaContable) => {
                setTipoPartidaContableToDelete(tipoPartidaContable);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setTipoPartidaContableToDelete(null);
            };
        
            const handleDeleteTipoPartidaContable = async () => {
                if (tipoPartidaContableToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
                        const response = await fetch(`${server}/CtbTipoPartidums/${tipoPartidaContableToDelete.id}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchTiposPartidasContables(); // Recargar la lista de razas
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Tipo de partida eliminado con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar el tipo de partida:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar el tipo de partida: ' + error,
                        });            }
                }
            };
        
            const filteredTipoPartidaContable = tiposPartidaContable.filter(tipoPartidaContable => tipoPartidaContable.descripcionTipoPartida?.toLowerCase().includes(searchQuery.toLowerCase()));
        
       const handleCancelarEdicion = () => {
            setEditTipoPartidaContable(null);
       };

return (
<>
    <div className="x_title">
        </div>

        <div className="x_content">
            <br />

            <AddTipoPartidaContable handleNewTipoPartidaContable={handleNewTipoPartidaContable} editTipoPartidaContable={editTipoPartidaContable} cancelarEdicion={handleCancelarEdicion}/>

            <div className="ln_solid" />

            <h2>Tipo de partidas contables existentes</h2>

            <div className="row">
                <div className="col-md-6 col-sm-4 offset-md-3">
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Tipo partida"
                        placeholder="Buscar..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{ marginBottom: '20px' }}
                    />

                   <div className="table-responsive">
                                               <TableContainer component={Paper}>
                                                   <Table>
                                                       <TableHead>
                                                           <TableRow>
                                                              <TableCell>Código</TableCell>
                                                               <TableCell>Descripción</TableCell>
                                                                <TableCell>Es automatica</TableCell>
                                                               <TableCell align="right">Acciones</TableCell>
                                                           </TableRow>
                                                       </TableHead>
                                                       <TableBody>
                                                           {filteredTipoPartidaContable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tipoPartidaContable) => (
                                                                   <TableRow key={tipoPartidaContable.id}>
                                                                       <TableCell component="th" scope="row">
                                                                           {tipoPartidaContable.codigo}
                                                                       </TableCell>
                                                                       <TableCell component="th" scope="row">
                                                                           {tipoPartidaContable.descripcionTipoPartida}
                                                                       </TableCell>
                                                                       <TableCell component="th" scope="row">
                                                                            {tipoPartidaContable.automatica ? 'Si' : 'No'}
                                                                       </TableCell>
                                                                       <TableCell align="right">
                                                                           <Button onClick={() => setEditTipoPartidaContable(tipoPartidaContable)} color="primary" disabled={!tienePermiso('Editar Tipo Partida Contable')}>
                                                                               Editar
                                                                           </Button>
                                                                           <Button onClick={() => handleOpenDialog(tipoPartidaContable)} color="secondary" disabled={!tienePermiso('Eliminar Tipo Partida Contable')}>
                                                                               Eliminar
                                                                           </Button>
                                                                       </TableCell>
                                                                   </TableRow>
                                                               ))}
                                                           
                                                       </TableBody>
                                                   </Table>
                   
                                                   <TablePagination
                                                       rowsPerPageOptions={[5, 10, 25]}
                                                       component="div"
                                                       count={filteredTipoPartidaContable.length}
                                                       rowsPerPage={rowsPerPage}
                                                       page={page}
                                                       onPageChange={handleChangePage}
                                                       onRowsPerPageChange={handleChangeRowsPerPage}
                                                       labelRowsPerPage="Filas por página:"
                                                       labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                                   />
                                               </TableContainer>
                   
                                               <Dialog open={openDialog}
                                                   onClose={handleCloseDialog}
                                                   aria-labelledby="alert-dialog-title"
                                                   aria-describedby="alert-dialog-description">
                                                   <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                                   <DialogContent>
                                                       <DialogContentText id="alert-dialog-description">
                                                           ¿Estás seguro de que quieres eliminar este tipo de partida contable?
                                                       </DialogContentText>
                                                   </DialogContent>
                                                   <DialogActions>
                                                       <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                                       <Button onClick={handleDeleteTipoPartidaContable} color="primary" autoFocus disabled={!tienePermiso('Eliminar Tipo Partida Contable')}>Eliminar</Button>
                                                   </DialogActions>
                                               </Dialog>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </>
                   

     
    );
}

export default GestionTipoPartidaContable;